import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LoanApplicationDocumentType} from '../model/loan-application-document-type.model';
import {ConfigService} from './config.service';
import {AddressProofType} from '../model/address-proof-type.model';
import {UserDocument} from '../model/user-document.model';

@Injectable()
export class UserDocumentService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async create(type: LoanApplicationDocumentType | AddressProofType, fileIds: string[]): Promise<string> {
        const url = `${this.configService.baseUrl()}user-document`;
        const response = await this.httpClient.post<{ id: string }>(url, {type, fileIds}).toPromise();
        return response.id;
    }

    public async getByDocumentId(documentId: string): Promise<UserDocument> {
        const url = `${this.configService.baseUrl()}user-document/${documentId}`;
        return await this.httpClient.get<UserDocument>(url).toPromise();
    }
}
